<template>
    <div>
        <div class="vx-row">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <div @click.prevent="downloadFile()"
                        class="btn-add-new ml-2 p-3 mb-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                >
                    <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4"/>
                    <span class="ml-2 text-base text-primary">Télécharger le fichier</span>
                </div>
            </div>
            <div v-if="evaluation.type_response == 'checkbox' || evaluation.type_response == 'radio'" class="flex flex-wrap-reverse items-center data-list-btn-container">
                <div @click="showImportFile()"
                        class="btn-add-new ml-2 p-3 mb-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                >
                    <feather-icon icon="FileIcon" svgClasses="h-4 w-4"/>
                    <span class="ml-2 text-base text-primary">Importer</span>
                </div>
            </div>

            <div v-if="evaluation.type_response == 'checkbox' || evaluation.type_response == 'radio'" class="flex flex-wrap-reverse items-center data-list-btn-container">
                <div @click="exportQuestion()"
                        class="btn-add-new ml-2 p-3 mb-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                >
                    <feather-icon icon="FileIcon" svgClasses="h-4 w-4"/>
                    <span class="ml-2 text-base text-primary">Exporter</span>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <import-question
                    :isPromptActive="addNewPromptFile"
                    @closeFile="toggleDataPromptFile"
                    :loadQuestionnaireByEvaluation="loadQuestionnaireByEvaluation"
            />
            <add-question
                    :isPromptActive="addNewPrompt"
                    @closePrompt="toggleDataPrompt"
                    :type="evaluation.type_response"
                    :addQuestion="addQuestion"
                    :nombreQuestion="nbrQuestion"
                    :evaluation="evaluation"
                    :idQuestionnaire="idQuestionnaire"
            />
            <edit-question
                    :isPromptActiveEdit="editNewPrompt"
                    @closeEditPrompt="toggleDataPromptEdit"
                    :dataEdit="editQuestionData"
                    :callBackAfterEditQuestion="callBackAfterEditQuestion"
                    :showing="showing"

            />
            <detail-question
                    :isActive="isActive"
                    :singleData="el"
                    @closeDetail="toggleDatacloseDetail"
            />
            <div class="vx-col w-full lg:w-1/3">
                <vs-card>
                    <div slot="header">
                        <span v-if="editQuestionnaire.quizz_id > 0">Modifier le questionnaire</span>
                        <span v-else>Ajouter un questionnaire</span>
                    </div>
                    <vs-row style="margin-bottom:10px">
                        <vs-col>
                            <vs-input class="w-full" label="Titre du questionnaire"
                                      :danger="error.title ? true : false"
                                      :danger-text="error.title ? error.title[0] : ''"
                                      v-model="questionnaire_form.title"
                            />
                        </vs-col>
                    </vs-row>
                    <vs-row>
                        <vs-col>
                            <vs-textarea class="w-full" label="Description du questionnaire"
                                         :danger="error.description ? true : false"
                                         :danger-text="error.description ? error.description[0] : ''"
                                         v-model="questionnaire_form.description"
                            ></vs-textarea>
                        </vs-col>
                    </vs-row>
                    <vs-row style="margin-top:5px">
                        <div class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                            <vs-button :disabled="disabled_btn" color="primary" @click="saveQuestionnaire()" type="border">Enregistrer</vs-button>
                            <vs-button :disabled="disabled_btn" v-if="editQuestionnaire.quizz_id" @click="cancelEditQuestionnaire()" color="danger" type="border">Annuler</vs-button>
                        </div>
                    </vs-row>
                </vs-card>
            </div>
            <div class="vx-col w-full lg:w-2/3">
                <vs-card>
                    <div slot="header">Liste des questionnaires</div>
                    <div v-if="questionnaires.length > 0">
                        <vs-collapse :accordion="true">
                            <vs-collapse-item :ref="'questionnaire'+key" v-for="(quetionnaireItem, key) in questionnaires" :key="key">
                                <div slot="header">
                                    <span style="font-size:16px !important">{{ quetionnaireItem.title }}</span>
                                </div>
                                <vs-table style="min-height:500px !important" :ref="'table'+key" max-items="5" :data="quetionnaireItem.questions">
                                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                                        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                                            <vs-button color="primary" class="mr-1" type="border" size="small" @click="showAddQuestion(quetionnaireItem)">Ajouter une question</vs-button>
                                            <vs-button color="primary" class="mr-1" type="border" size="small" @click="alterQuestionnaire(quetionnaireItem)">Modifier le questionnaire</vs-button>
                                            <vs-button color="danger" class="mr-1" type="border" size="small" @click="removeQuestionnaire(quetionnaireItem)">Supprimer le questionnaire</vs-button>
                                        </div>
                                    </div>
                                    <template slot="thead">
                                        <vs-th sort-key="title">Question</vs-th>
                                        <vs-th sort-key="categorie">Point</vs-th>
                                        <vs-th sort-key="status">Niveau</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>
                                    <template slot-scope="{ data }">
                                        <tbody>
                                        <vs-tr :data="question" :key="indextr" v-for="(question, indextr) in data">
                                            <vs-td>{{ question.question | truncate(50) }}</vs-td>
                                            <vs-td>{{ question.marks }}</vs-td>
                                            <vs-td>
                                                <span v-if="question.difficulty_level == 'medium'">Moyen</span>
                                                <span v-else-if="question.difficulty_level == 'easy'">Facile</span>
                                                <span v-else>Difficile</span>
                                            </vs-td>
                                            <vs-th>
                                                <vs-td class="whitespace-no-wrap">
                                                    <div class="flex">
                                                        <feather-icon @click="removeQuestion(quetionnaireItem, question)"
                                                                      icon="DeleteIcon"
                                                                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                                      class="mr-2"
                                                        />
                                                        <feather-icon @click="showEditPromt(quetionnaireItem, question)"
                                                                      icon="EditIcon"
                                                                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                                      class="mr-2"
                                                        />
                                                        <feather-icon
                                                                icon="EyeIcon" @click="detailQ(question)"
                                                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                                class="mr-2"
                                                        />
                                                    </div>
                                                </vs-td>
                                            </vs-th>
                                        </vs-tr>
                                        </tbody>
                                    </template>
                                </vs-table>
                            </vs-collapse-item>
                        </vs-collapse>
                    </div>
                </vs-card>
            </div>
        </div>
    </div>
</template>

<script>
import addQuestion from './addQuestion'
import editQuestion from './editQuestion'
import detailQuestion from './detailQuestion'
import ImportQuestion from "./importQuestion";
const EMPTY_QUESTIONNAIRE_FORM = {
    title: '',
    description: '',
    quizz_id: null
};
export default {
    components:{
        ImportQuestion,
        addQuestion, editQuestion, detailQuestion
    },
    data: (vm) => ({
        open: vm.initialize(),
        isActive: false,
        nbrQuestion: 0,
        questionnaires: [],
        error: [],
        disabled_btn: false,
        questionnaire_form:{
            title: '',
            description: '',
            quizz_id: null
        },
        evaluation: {},
        addNewPrompt: false,
        addNewPromptFile: false,
        tmpQuestion: {},
        idQuestionnaire: 0,
        editQuestionnaire: {},
        editNewPrompt: false,
        editQuestionData: {},
        tmpQuestionToEdit: {},
        showing: false,
        el: {}
    }),
    methods:{
        async downloadFile(){
            try {
                this.$vs.loading()
                const response = await this.$http({
                    url: 'questionnaires/file',
                    method: 'GET',
                    responseType: 'blob',
                })
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'QCM.xlsx')
                document.body.appendChild(link)
                link.click()
                this.$vs.loading.close()
            }catch (e) {
                this.$vs.loading.close()
            }
        },
        async exportQuestion(){
            try {
                this.$vs.loading()
                const response = await this.$http({
                    url: 'questionnaires/export?id='+this.evaluation.id,
                    method: 'GET',
                    responseType: 'blob',
                })
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'questions.xlsx')
                document.body.appendChild(link)
                link.click()
                this.$vs.loading.close()
            }catch (e) {
                this.$vs.loading.close()
            }
        },
        initialize(){
            return true
        },
        detailQ(el){
            this.el = el
            this.isActive = true
        },
        callBackAfterEditQuestion(model){
            /*let i = this.questionnaires.indexOf(this.tmpQuestion)
            let index = this.questionnaires[i].questions.indexOf(this.tmpQuestionToEdit)
            let toReplace = model
            delete toReplace.questionnaire
            this.questionnaires[i].questions[index] = toReplace
            this.tmpQuestionToEdit = {}
            this.tmpQuestion = {}*/

            this.loadQuestionnaireByEvaluation()
        },
        showEditPromt(questionnaire, question){
            this.tmpQuestionToEdit = question
            this.tmpQuestion = questionnaire
            this.editQuestionData = {
                id: question.id,
                instructions: question.instructions,
                points: question.marks,
                question: question.question,
                answers: question.answers,
                questionnaire_id: question.questionnaire_id,
                type: question.type,
                difficulty_level: question.difficulty_level
            }
            this.editNewPrompt = true
            this.showing = true
        },
        cancelEditQuestionnaire(){
            this.questionnaire_form = { ...EMPTY_QUESTIONNAIRE_FORM }
            this.editQuestionnaire = {}
        },
        alterQuestionnaire(questionnaire){
            this.editQuestionnaire = questionnaire
            this.questionnaire_form.title = this.editQuestionnaire.title
            this.questionnaire_form.description = this.editQuestionnaire.description
            this.questionnaire_form.quizz_id = this.editQuestionnaire.quizz_id
            this.questionnaire_form.id = this.editQuestionnaire.id

        },
        removeQuestionnaire(questionnaire){
            if (confirm('Voulez vous supprimer ce questionnaire ?')){
                this.$vs.loading()
                this.$http.delete('/questionnaires/delete/'+questionnaire.id).then((response) =>{
                    window.getApp.success("Questionnaire supprimé", {})
                    let index = this.questionnaires.indexOf(questionnaire)
                    this.questionnaires.splice(index, 1)
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    console.log(error)
                })
            }
        },

        removeQuestion(questionnaire, question){
            if (confirm('Voulez vous supprimer cette quesiton ?')){
                this.$vs.loading()
                this.$http.delete('/questions/delete/'+question.id).then((response) =>{
                    let i = this.questionnaires.indexOf(questionnaire)
                    let j = this.questionnaires[i].questions.indexOf(question)
                    this.questionnaires[i].questions.splice(j, 1)
                    window.getApp.success("Question supprimé", {})
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    console.log(error)
                })
            }
        },
        addQuestion(element){
            const dataToPush = { ...element }
            delete dataToPush.questionnaire
            let index = this.questionnaires.indexOf(this.tmpQuestion)
            this.questionnaires[index].questions.push(dataToPush)
            //this.loadQuestionnaireByEvaluation()
        },
        showImportFile(){
            this.addNewPromptFile = true
        },
        toggleDataPrompt(val = false) {
            this.addNewPrompt = val;
        },
        toggleDataPromptFile(val = false) {
            this.addNewPromptFile = val;
        },
        toggleDataPromptEdit(val = false){
            this.editNewPrompt = val
            this.showing = val
        },
        toggleDatacloseDetail(val = false){
            this.isActive = val
        },
        showAddQuestion(questionnaire){
            this.tmpQuestion = questionnaire
            this.nbrQuestion = questionnaire.questions.length
            this.idQuestionnaire = questionnaire.id
            this.addNewPrompt = true
        },
        loadQuestionnaireByEvaluation(){
            this.$vs.loading()
            let id = this.$route.params.id
            this.$http.get('/questionnaires/evaluation/'+id).then((response) =>{
                this.questionnaires = response.data.questionnaires
                this.evaluation = response.data.evaluation
                this.$vs.loading.close()
            }).catch((error) =>{
                console.log(error)
                this.$vs.loading.close()
            })
        },
        saveQuestionnaire(){
            if (this.editQuestionnaire.quizz_id){
                this.disabled_btn = true
                let id = this.questionnaire_form.id
                //delete this.questionnaire_form.id
                this.$http.post('/questionnaires/update/'+id, this.questionnaire_form).then((response) =>{
                    this.disabled_btn = false
                    this.error = []
                    if (response.data.status){
                        console.log(this.editQuestionnaire)
                        let index = this.questionnaires.indexOf(this.editQuestionnaire)
                        console.log(index)
                        this.questionnaires[index].title = this.questionnaire_form.title
                        this.questionnaires[index].description = this.questionnaire_form.description
                        this.cancelEditQuestionnaire()
                        window.getApp.success("Questionnaire modifié", {})
                    }
                }).catch((error) => {
                    console.log(this.questionnaire_form.id)
                    console.log(error)
                    this.error = error.response.data.errors
                    this.disabled_btn = false
                })
            }else{
                if (this.evaluation.nbr_questionnaire > this.questionnaires.length){
                    this.disabled_btn = true
                    let quizz_id = this.$route.params.id
                    this.questionnaire_form.quizz_id = quizz_id
                    this.$http.post('/questionnaires/create', this.questionnaire_form).then((response) =>{
                        this.disabled_btn = false
                        this.error = []
                        if (response.data.status){
                            this.questionnaire_form = { ...EMPTY_QUESTIONNAIRE_FORM }
                            let toPush = response.data.model
                            toPush.questions = []
                            this.questionnaires.push(toPush)
                            window.getApp.success("Questionnaire ajouté", {})
                        }
                    }).catch((error) => {
                        console.log(error)
                        this.error = error.response.data.errors
                        this.disabled_btn = false
                    })
                }else{
                    this.$vs.notify({
                        time: 30000,
                        title: 'Erreur!',
                        text: "Cette évaluaiton n'autorise que la création de "+this.evaluation.nbr_questionnaire+" questionnaire(s)",
                        color: 'danger',
                        iconPack: 'feather',
                        position: 'top-right',
                        icon: 'icon-check-circle'
                    })
                }
            }
        }
    },
    mounted(){
        this.loadQuestionnaireByEvaluation()
    }
}
</script>
<style>
    .vs-table--content {
        width: 100%;
        overflow-x: auto;
        overflow-y: scroll;
        height: 500px;
    }
</style>